var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoute(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 15.175,
    height: 22.025,
    fill: "#006",
    stroke: "#19bc9c",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43-2",
    "data-name": "Rectangle 43",
    width: 15.175,
    height: 22.025,
    fill: "none",
    stroke: "#19bc9c",
    strokeWidth: 1.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "route",
    transform: "translate(-510 -358)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 72,
    height: 72,
    rx: 12,
    transform: "translate(510 358)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "route_icon",
    "data-name": "route icon",
    transform: "translate(522 370)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 48,
    height: 48,
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_346",
    "data-name": "Group 346",
    transform: "translate(6.667 6.666)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    d: "M4.264,1.827A2.436,2.436,0,1,0,6.7,4.264,2.439,2.439,0,0,0,4.264,1.827M4.264,0A4.264,4.264,0,1,1,0,4.264,4.264,4.264,0,0,1,4.264,0Z",
    transform: "translate(3.323 16.85)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    d: "M4.264,1.827A2.436,2.436,0,1,0,6.7,4.264,2.439,2.439,0,0,0,4.264,1.827M4.264,0A4.264,4.264,0,1,1,0,4.264,4.264,4.264,0,0,1,4.264,0Z",
    transform: "translate(22.815 3.655)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_646",
    "data-name": "Path 646",
    d: "M-1504.649,2744.929a10.334,10.334,0,0,1-1.437-.1.915.915,0,0,1-.754-1.05.908.908,0,0,1,1.049-.752c.075.008,3.118.459,4.9-1.021a3.967,3.967,0,0,0,1.311-3.148c.08-3.3.628-5.268,1.834-6.586,1.261-1.381,3.157-1.858,5.154-2.261a.912.912,0,0,1,1.076.715.914.914,0,0,1-.712,1.076c-3.827.777-5.385,1.318-5.526,7.1a5.748,5.748,0,0,1-1.977,4.516A7.775,7.775,0,0,1-1504.649,2744.929Z",
    transform: "translate(1516.779 -2709.793)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_325",
    "data-name": "Group 325",
    transform: "translate(0 13.401)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_324",
    "data-name": "Group 324",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_652",
    "data-name": "Path 652",
    d: "M15.164,7.582H13.336a5.754,5.754,0,1,0-11.509,0H0a7.582,7.582,0,1,1,15.164,0Z",
    transform: "translate(0 0)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_653",
    "data-name": "Path 653",
    d: "M6.435,20.956a.914.914,0,0,1-.727-1.467,55.659,55.659,0,0,0,3.372-5.12c2.117-3.655,3.173-6.6,3.053-8.5a.914.914,0,1,1,1.824-.115c.145,2.305-.967,5.519-3.306,9.551A56.421,56.421,0,0,1,7.163,20.6.912.912,0,0,1,6.435,20.956Z",
    transform: "translate(1.205 1.068)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_654",
    "data-name": "Path 654",
    d: "M7.536,20.956a.912.912,0,0,1-.728-.361A56.423,56.423,0,0,1,3.319,15.3C.98,11.27-.132,8.057.013,5.751a.914.914,0,1,1,1.824.115C1.59,9.785,6.391,17.029,8.262,19.49a.914.914,0,0,1-.727,1.467Z",
    transform: "translate(0 1.068)",
    fill: "#006"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_326",
    "data-name": "Group 326",
    transform: "translate(19.492 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_324-2",
    "data-name": "Group 324",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_652-2",
    "data-name": "Path 652",
    d: "M15.164,7.582H13.336a5.754,5.754,0,1,0-11.509,0H0a7.582,7.582,0,1,1,15.164,0Z",
    transform: "translate(0 0)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_653-2",
    "data-name": "Path 653",
    d: "M6.435,20.956a.914.914,0,0,1-.727-1.467,55.659,55.659,0,0,0,3.372-5.12c2.117-3.655,3.173-6.6,3.053-8.5a.914.914,0,1,1,1.824-.115c.145,2.305-.967,5.519-3.306,9.551A56.421,56.421,0,0,1,7.163,20.6.912.912,0,0,1,6.435,20.956Z",
    transform: "translate(1.205 1.068)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_654-2",
    "data-name": "Path 654",
    d: "M7.536,20.956a.912.912,0,0,1-.728-.361A56.423,56.423,0,0,1,3.319,15.3C.98,11.27-.132,8.057.013,5.751a.914.914,0,1,1,1.824.115C1.59,9.785,6.391,17.029,8.262,19.49a.914.914,0,0,1-.727,1.467Z",
    transform: "translate(0 1.068)",
    fill: "#19bc9c"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoute);
export default __webpack_public_path__ + "static/media/route.2d1fee7440a7a3f1115362cdb07cdf71.svg";
export { ForwardRef as ReactComponent };